import {StatsigClient as VendorStatsigClient} from '@statsig/react-bindings';

const IS_PROD = process.env.NODE_ENV === 'production';
const statusListeners = new Set();
let clientInstance = null;
let initPromise = null;
let status = {isInitialized: false, isUserInitialized: false};

const setStatus = updates => {
    status = {...status, ...updates};

    statusListeners.forEach(listener => listener(status));
};

const warn = (...args) => {
    if (IS_PROD) {
        return;
    }

    // eslint-disable-next-line no-console
    console.warn('[Statsig]', ...args);
};

export const StatsigClient = {
    get() {
        return clientInstance;
    },

    init(sdkKey, statsigUser = {}, options = {}) {
        if (clientInstance) {
            return clientInstance;
        }

        if (!sdkKey) {
            // No key -> there will never be a client and gates stay false
            // forever; mark both stages settled so UI renders defaults.
            setStatus({isInitialized: true, isUserInitialized: true});

            return null;
        }

        clientInstance = new VendorStatsigClient(sdkKey, statsigUser, options);

        initPromise = clientInstance
            .initializeAsync()
            .then(() => setStatus({isInitialized: true}))
            .catch(err => warn('initializeAsync failed', err));

        return clientInstance;
    },

    getStatus() {
        return status;
    },

    onStatusChange(listener) {
        statusListeners.add(listener);

        return () => statusListeners.delete(listener);
    },

    async updateUser(statsigUser = {}) {
        if (!clientInstance) {
            return;
        }

        if (initPromise) {
            await initPromise;
        }

        clientInstance
            .updateUserAsync(statsigUser)
            .then(() => setStatus({isUserInitialized: true}))
            .catch(err => warn('updateUserAsync failed', err));
    },
};
